import emojiRegex from 'emoji-regex';

export function removeEmojis(str: string): string {
  return str.replace(emojiRegex(), '');
}
